import React, { createContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { _header } from 'src/globals';
import AuthService from '../authServices/AuthServices';
import FallbackLoaderComponent from '../components/fallback-loader/FallbackLoader.component';
import { useGetLoggedInUserMutation } from '../services/account.service';
import { setLoggedinUser } from '../store/stateSlice/userSlice';
import { useAppDispatch } from '../store/stateTypeHook';
import { ISelectedAgent, setDefaultBookingAgent } from '../store/stateSlice/bookingSlice';
import { getAgentFilterValue } from '../utils/helperFunctions';

type AuthContext = {
    signinRedirectCallback: () => void;
    logout: () => void;
    signoutRedirectCallback: () => void;
    isAuthenticated: () => boolean;
    signinRedirect: () => void;
    createSigninRequest: () => any;
    getUser: () => any;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthContext = createContext<AuthContext>({} as AuthContext);

export const AuthConsumer = AuthContext.Consumer;

export const AUTH_SERVICE = new AuthService();
export function AuthProvider({ children }) {
    const Auth = AUTH_SERVICE.isAuthenticated();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [getLoggedInUser, loggedinUserResponse] = useGetLoggedInUserMutation();

    useEffect(() => {
        if (Auth) {
            const oidcStorage = JSON.parse(
                localStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTHORITY}:${process.env.REACT_APP_CLIENT_ID}`)
            );
            _header.Authorization = `bearer ${oidcStorage.access_token}`;
            getLoggedInUser('loggedinUser');
        }
    }, [Auth]);

    useEffect(() => {
        if (loggedinUserResponse.isSuccess) {
            const { systemPermissions } = JSON.parse(JSON.stringify(loggedinUserResponse.data));
            systemPermissions.push(99);

            dispatch(
                setLoggedinUser(Object.assign({}, loggedinUserResponse.data, { systemPermissions: systemPermissions }))
            );

            const agent = getAgentFilterValue(loggedinUserResponse.data);
            dispatch(setDefaultBookingAgent(agent as ISelectedAgent));

            // dispatch(setLoggedinUser(loggedinUserResponse.data));
        }
        if (loggedinUserResponse.isError) {
            navigate('/');
            AUTH_SERVICE.logout();
        }
    }, [loggedinUserResponse]);

    return (
        <AuthContext.Provider value={AUTH_SERVICE}>
            {loggedinUserResponse.isLoading ? (
                <FallbackLoaderComponent />
            ) : loggedinUserResponse.isError ? (
                AUTH_SERVICE.logout()
            ) : (
                children
            )}
        </AuthContext.Provider>
    );
}
